/**
 * Fenice Italy Business API
 * # Fenice Italy Business API  ## General Http Status: HTTP STATUS CODE | DESCRIPTION --- | --- 400 | Business error or general error 401 | Expired token 403 | Access token does not have the required scope 404 | Not found 500 | Internal error  ## Specific Error Codes: Verti has specific errors based on validations, in error field *code*  CODE | DESCRIPTION --- | --- KOIT001 | Plate not valid from SIC/SITA. KOIT002 | Vehicle plate number is not valid. KOIT003 | Login failed. Password is not correct.  ## Annotations:   - In those services that return a list of items, in the case of not found any of them, it will return an empty list.   - For date format, standard ISO 8601. (YYYY-MM-DDThh:mm:ss.sTZD)
 *
 * OpenAPI spec version: 1.2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { SecureLink } from './secureLink';

export interface CredentialUser {
  activationDate?: Date;
  affinity?: string;
  alliance?: string;
  cellPhone?: string;
  channel?: CredentialUser.ChannelEnum;
  creationDate?: Date;
  customerRetentionFlag?: boolean;
  customerType?: string;
  deactivationDate?: Date;
  email?: string;
  existingMyLSID?: number;
  fromInvite?: boolean;
  id?: number;
  lastLoginOkDate?: Date;
  lastName?: string;
  login?: string;
  loginAttempts?: number;
  mailSecureLink?: SecureLink;
  mergedIntoId?: string;
  mobilePhone?: string;
  name?: string;
  password?: string;
  passwordLastModifiedDate?: Date;
  phone?: string;
  posUser?: boolean;
  registrationFromMyLS?: boolean;
  registrationFromQolNewQuote?: boolean;
  sendConfirmRegistration?: boolean;
  status?: CredentialUser.StatusEnum;
  surname?: string;
  type?: CredentialUser.TypeEnum;
  username?: string;
}
export namespace CredentialUser {
  export type ChannelEnum =
    | 'WEB_SITE'
    | 'MOBILE'
    | 'PHONE'
    | 'EXTRA'
    | 'AGGREGATOR'
    | 'GW_CC'
    | 'GW_PC'
    | 'GW_BC'
    | 'GW_CM'
    | 'AGGREGATOR_BATCH'
    | 'comeround';
  export const ChannelEnum = {
    WEBSITE: 'WEB_SITE' as ChannelEnum,
    MOBILE: 'MOBILE' as ChannelEnum,
    PHONE: 'PHONE' as ChannelEnum,
    EXTRA: 'EXTRA' as ChannelEnum,
    AGGREGATOR: 'AGGREGATOR' as ChannelEnum,
    GWCC: 'GW_CC' as ChannelEnum,
    GWPC: 'GW_PC' as ChannelEnum,
    GWBC: 'GW_BC' as ChannelEnum,
    GWCM: 'GW_CM' as ChannelEnum,
    AGGREGATORBATCH: 'AGGREGATOR_BATCH' as ChannelEnum,
    Comeround: 'comeround' as ChannelEnum,
  };
  export type StatusEnum =
    | 'ENABLED'
    | 'SECURE_LINK'
    | 'MERGED'
    | 'TO_BE_COMPLETE'
    | 'TO_BE_CONFIRM'
    | 'NOT_VALID'
    | 'EXIST_MYDL'
    | 'TO_BE_COMPLETED'
    | 'TO_BE_COMPLETED_WITH_MYLS'
    | 'AVAILABLE'
    | 'AVAILABLE_WITH_MYLS'
    | 'TO_BE_CONFIRMED'
    | 'TO_BE_CONFIRMED_WITH_MYLS';
  export const StatusEnum = {
    ENABLED: 'ENABLED' as StatusEnum,
    SECURELINK: 'SECURE_LINK' as StatusEnum,
    MERGED: 'MERGED' as StatusEnum,
    TOBECOMPLETE: 'TO_BE_COMPLETE' as StatusEnum,
    TOBECONFIRM: 'TO_BE_CONFIRM' as StatusEnum,
    NOTVALID: 'NOT_VALID' as StatusEnum,
    EXISTMYDL: 'EXIST_MYDL' as StatusEnum,
    TOBECOMPLETED: 'TO_BE_COMPLETED' as StatusEnum,
    TOBECOMPLETEDWITHMYLS: 'TO_BE_COMPLETED_WITH_MYLS' as StatusEnum,
    AVAILABLE: 'AVAILABLE' as StatusEnum,
    AVAILABLEWITHMYLS: 'AVAILABLE_WITH_MYLS' as StatusEnum,
    TOBECONFIRMED: 'TO_BE_CONFIRMED' as StatusEnum,
    TOBECONFIRMEDWITHMYLS: 'TO_BE_CONFIRMED_WITH_MYLS' as StatusEnum,
  };
  export type TypeEnum = 'CORNER' | 'MYDL' | 'SECURELINK' | 'X' | 'SECUREPIN';
  export const TypeEnum = {
    CORNER: 'CORNER' as TypeEnum,
    MYDL: 'MYDL' as TypeEnum,
    SECURELINK: 'SECURELINK' as TypeEnum,
    X: 'X' as TypeEnum,
    SECUREPIN: 'SECUREPIN' as TypeEnum,
  };
}
